"use client";
import { createContext, useContext } from "react";
import { ArticlePageProps } from "@/types/strapi/article";

export type ArticleSinglePageContextType = ArticlePageProps | null;

export const ArticleSinglePageContext = createContext<ArticleSinglePageContextType>(null);

export const useArticleSinglePageContext = () => useContext(ArticleSinglePageContext);
